<template>
  <main class="welcome">
    <IndexBlock
      class="welcome__block"
      v-for="(data, index) in stamps"
      :key="index"
      :data="data"
      :style="{
        pointerEvents: data.comingsoon ? 'none' : false,
      }"
    />
  </main>
</template>

<script>
import IndexBlock from '@/components/IndexBlock.vue';

export default {
  name: 'Welcome',
  components: {
    IndexBlock,
  },
  data() {
    return {
      stamps: [
        {
          url: 'amsterdam',
          id: 'amsterdam',
          image: '/img/welcome/amsterdam.png',
          title: 'Amsterdam',
          subtitle: 'Workshops: 19 Feb \'20<br>Conference: 20 - 21 Feb \'20',
          caption: 'Jump in',
          routerLink: true,
          soldout: 'soldout',
        },
        {
          url: 'toronto',
          id: 'toronto',
          image: '/img/welcome/toronto.png',
          title: 'Toronto',
          subtitle: 'Workshops: 14 Jul \'20 <br>Conference 15 - 16 Jul \'20',
          caption: 'Jump in',
          routerLink: true,
          soldout: false,
        },
        {
          url: '/',
          id: 'san-francisco',
          image: '/img/welcome/san-francisco.png',
          title: 'San Francisco',
          subtitle: 'Workshops: 27 Oct \'20 <br>Conference 28 - 29 Oct \'20',
          caption: 'Jump in',
          routerLink: true,
          soldout: 'comingsoon',
          comingsoon: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.welcome {
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: column wrap;

  @include mq(ipadP) {
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }

  &__block {
    width: 100%;
    height: 85vh;
    height: calc(var(--vh, 1vh) * 85);

    &:nth-child(1) {
      background-color: #7FCDDA;
    }

    &:nth-child(2) {
      background-color: #FEAEA7;
    }

    &:nth-child(3) {
      background-color: #3f7fc1;
    }

    &::v-deep .index-block__title {
        @include fluid-type(
          320px,
          2560px,
          40px,
          85px,
          60px,
          105px
        );

        @include mq(ipadP) {
          @include fluid-type(
            320px,
            2560px,
            30px,
            65px,
            40px,
            65px
          );
        }
      }

    @include mq(ipadP) {
      height: 100%;
      width: 33.3%;
    }
  }
}
</style>
